module.exports = __webpack_public_path__ + "static/media/ledneon (1).fc252ffb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/LedNeon/ledneon (1).jpg
// module id = 329
// module chunks = 0